/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VideoSearchSortBy { 
    field: VideoSearchSortBy.FieldEnum;
    order: VideoSearchSortBy.OrderEnum;
}
export namespace VideoSearchSortBy {
    export const FieldEnum = {
        Title: 'title',
        Description: 'description',
        Date: 'date',
        DurationInSeconds: 'duration_in_seconds',
        Status: 'status',
        Gender: 'gender',
        Category: 'category',
        Competition: 'competition',
        Id: 'id'
    } as const;
    export type FieldEnum = typeof FieldEnum[keyof typeof FieldEnum];
    export const OrderEnum = {
        Asc: 'ASC',
        Desc: 'DESC'
    } as const;
    export type OrderEnum = typeof OrderEnum[keyof typeof OrderEnum];
}


